// import React, { useEffect, useState } from "react";
// import { FaPlus, FaRegTrashAlt } from "react-icons/fa";
// import { TbBallpen } from "react-icons/tb";
// import "react-phone-input-2/lib/style.css";
// import { NavLink } from "react-router-dom";
// import apiKey from "../../../config/apiKey";
// import axios from "axios";
// import { toast } from "react-toastify";
// import Select from "react-select";
// import { useMemo } from "react";
// import { getHitID } from "../../../config/HitIDStorage";
// const typeIdToOption = {
//   1: "home",
//   2: "online",
//   3: "both",
// };

// const AdminAddSubject = () => {
//     const teacher_id = getHitID();
    
//   const [typeId, setTypeId] = useState(null);
//   const admin = JSON.parse(localStorage.getItem("edo-admin"));
// //   const Id = admin ? admin.admin.id : "";
//   const [selectedOption, setSelectedOption] = useState([]);
//   const [loading, setLoading] = useState(true); // Add loading state

//   useEffect(() => {
//     setLoading(true); // Start loading before data fetch
//     axios
//       .get(`${apiKey}/api/edolutions/teacher/classes`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         setClasses(res.data);
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//     axios
//       .get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         setMySubjects(res.data);

//       })
//       .catch((err) => {
//         console.error(err);
//       })
//       .finally(() => {
//         setLoading(false);
//       });
//   }, [teacher_id,admin?.token]);

//   useEffect(() => {
//     axios
//       .get(`${apiKey}/api/edolutions/admin/ad-subjects/user/${teacher_id}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         const fetchedTypeId = res.data.type_id;
//         setTypeId(fetchedTypeId);
//         // console.log("type id of the user is :", fetchedTypeId);
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   }, [teacher_id, admin?.token]);

//   useEffect(() => {
//     if (typeId !== null) {
//       setSelectedOption(typeIdToOption[typeId] || "");
//     }
//   }, [typeId]);

//   const [errors, setErrors] = useState({});
//   const [showModal, setShowModal] = useState(false);
//   const [showModalEdit, setShowModalEdit] = useState(false);
//   const [mySubjects, setMySubjects] = useState([]);
//   const [subjects, setSubjects] = useState([]);
//   const [id, setId] = useState([]);
//   const [editclass, setEditClass] = useState([]);
//   const [editsubject, setEditSubject] = useState([]);
//   const [edithome, setEditHome] = useState([]);
//   const [editCharge, setEditCharge] = useState([]);
//   const [classes, setClasses] = useState([]);
//   const [edit, setEdit] = useState([]);
//   const [formData, setFormData] = useState({
//     teacher_id: teacher_id,
//     class_id: "",
//     subjects: [],
//     type_id: typeId,
//     online_charges: "",
  
//   });
//   // const resetFormData=()=>{

//   //   }
//   const initialFormData = {
//     teacher_id: teacher_id,
//     class_id: "",
//     subjects: [],
//     type_id: typeId, // This should come from props or state
//     online_charges: "",
//     home_charges: "",
//   };

//   useEffect(() => {
//     if (typeId !== null) {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         type_id: typeId, // Update formData when typeId changes
//       }));
//     }
//   }, [typeId]);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//     setErrors({
//       ...errors,
//       [e.target.name]: "",
//     });
//   };

//   const [isLoading, setIsLoading] = useState(false); // Add isLoading state

//   const handleSubmit = (e) => {
//     e.preventDefault();
//     setFormData((prevFormData) => ({
//         ...prevFormData,
//         'teacher_id': teacher_id // Update formData when typeId changes
//       }));
//     // setIsLoading(true); // Set loading to true when the form is submitted

//     axios
//       .post(`${apiKey}/api/edolutions/admin/ad-subjects`, formData, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         toast.success(res.data.message, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//           style: {
//             backgroundColor: "#4FD1C5", // Customize background color
//             color: "#fff", // Customize text color
//           },
//         });

//         // Reset the form fields
//         setFormData({
//           class_id: "",
//           subjects: [],
//           type_id: typeId,
//           online_charges: "",
//           home_charges: "",
//         });

//         setSelectedOptions([]); // Reset the selected options
//         setShowModal(false); // Close the modal

//         // Refresh subjects
//         axios
//           .get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
//             headers: {
//               Authorization: `Bearer ${admin?.token}`,
//             },
//           })
//           .then((res) => {
//             setMySubjects(res.data);
            
//           })
//           .catch((err) => {
//             console.error(err);
//           });
//       })
//       .catch((err) => {
//         if (err.response && err.response.data && err.response.data.data) {
//           setErrors(err.response.data.data);
//         } else {
//           setErrors({ general: "An unexpected error occurred" });
//         }
//       })
//       .finally(() => {
//         setIsLoading(false); // Set loading to false after the request completes
//       });
//   };

//   const [isLoading2, setIsLoading2] = useState(false); // Add isLoading state

//   const handleSubmitEdit = (e) => {
//     setIsLoading2(true); // Set loading to true when the form is submitted
//     axios
//       .get(`${apiKey}/api/edolutions/teacher/classes`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         setClasses(res.data);
//       })
//       .catch((err) => {
//         console.error(err);
//       });

//     e.preventDefault();
//     axios
//       .put(`${apiKey}/api/edolutions/admin/ad-subjects/${id}`, formData, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         toast.success(res.data.message, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//           style: {
//             backgroundColor: "#4FD1C5", // Customize background color
//             color: "#fff", // Customize text color
//           },
//         });
//         setShowModalEdit(false);
//         setSelectedOptions("");
//         // window.location.reload();
//         axios
//           .get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
//             headers: {
//               Authorization: `Bearer ${admin?.token}`,
//             },
//           })
//           .then((res) => {
//             setMySubjects(res.data);
//           })
//           .catch((err) => {
//             console.error(err);
//           });
//       })
//       .catch((err) => {
//         if (err.response && err.response.data && err.response.data.data) {
//           setErrors(err.response.data.data);
//         } else {
//           setErrors({ general: "An unexpected error occurred" });
//         }
//       })
//       .finally(() => {
//         setIsLoading2(false); // Set loading to false after the request completes
//       });
//   };

//   const handleDeleteSubject = (id) => {
//     axios
//       .delete(`${apiKey}/api/edolutions/admin/ad-subjects/${id}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         toast.success(res.data.message, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//           style: {
//             backgroundColor: "#4FD1C5", // Customize background color
//             color: "#fff", // Customize text color
//           },
//         });
//         axios
//           .get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
//             headers: {
//               Authorization: `Bearer ${admin?.token}`,
//             },
//           })
//           .then((res) => {
//             setMySubjects(res.data);
//           })
//           .catch((err) => {
//             console.error(err);
//           });
//       })
//       .catch((err) => {
//         toast.error(err.response.data.message, {
//           position: "bottom-right",
//           autoClose: 5000,
//           hideProgressBar: false,
//           closeOnClick: true,
//           pauseOnHover: true,
//           draggable: true,
//           progress: undefined,
//           theme: "colored",
//         });
//       });
//   };

//   const handleFunctionEdit = (
//     id,
//     subject_name,
//     class_name,
//     home_charges,
//     online_charges
//   ) => {
//     setId(id);
//     setEditClass(class_name);
//     setEditSubject(subject_name);
//     setEditHome(home_charges);
//     setEditCharge(online_charges);
//     setShowModalEdit(true);
  
//     axios
//       .get(`${apiKey}/api/edolutions/admin/ad-subjects/${id}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
//         const defaultValueSub = res.data.map((sub) => {
//           return { value: sub.subject_id, label: sub.subject_name };
//         });

//         setSelectedOptions(defaultValueSub);

//         setEdit(res.data);

//         setEditCharge(res.data[0].online_charges);
//         setEditHome(res.data[0].home_charges);

//         setFormData({
//           ...formData,
//           teacher_id: teacher_id,
//           class_id: res.data[0].class_id,
//           subject_id: res.data.subject_id,
//           type_id: res.data[0].type_id,
//           online_charges: res.data[0].online_charges,
//           home_charges: res.data[0].home_charges,
//           subjects: defaultValueSub.map((value) => value.value),
//         });
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   };

//   const groupedSubjects = useMemo(() => {
//     const groups = {};

//     mySubjects.forEach((subject) => {
//       if (!groups[subject.id]) {
//         groups[subject.id] = [];
//       }
//       groups[subject.id].push(subject);
//     });
//     return groups;
//   }, [mySubjects]);

//   useEffect(() => {
//     // console.log(formData.class_id);
//     axios
//       .get(`${apiKey}/api/edolutions/teacher/classes/${formData.class_id}`, {
//         headers: {
//           Authorization: `Bearer ${admin?.token}`,
//         },
//       })
//       .then((res) => {
     
//         setSubjects(res.data);
//       })
//       .catch((err) => {
//         console.error(err);
//       });
//   }, [formData.class_id, admin?.token]);

//   const options = subjects.map((item) => ({
//     value: item.subject_id,
//     label: item.subject_name,
//   }));
//   const [selectedOptions, setSelectedOptions] = useState([]);
//   // const handleChangeSub = (selectedOptions) => {
//   //   setSelectedOptions(selectedOptions);
//   //   // Example of setting a value based on the selected options
//   //   const selectedValues = selectedOptions.map((option) => option.value); // Extracting selected values
//   //   setFormData({
//   //     ...formData,
//   //     subjects: selectedValues,
//   //   });
//   //   // console.log("Selected Values:", selectedValues);
//   // };

//   const [errorMessage, setErrorMessage] = useState("");

//   const handleChangeSub = (selectedOptions) => {
//     // Extracting selected values
//     const selectedValues = selectedOptions.map((option) => option.value);

//     // Extracting subject IDs from mySubjects
//     const existingSubjectIds = mySubjects.map((subject) => subject.subject_id);

//     // Filter out duplicates
//     const filteredSelectedValues = selectedValues.filter(
//       (value) => !existingSubjectIds.includes(value)
//     );

//     if (filteredSelectedValues.length !== selectedValues.length) {
//       // If some subjects were removed, show an error message
//       setErrorMessage(
//         "Some subjects are already selected and have been removed."
//       );
//     } else {
//       // Clear the error message if there are no duplicates
//       setErrorMessage("");
//     }

//     // Update the selected options
//     setSelectedOptions(
//       selectedOptions.filter(
//         (option) => !existingSubjectIds.includes(option.value)
//       )
//     );

//     // Update the form data
//     setFormData({
//       ...formData,
//       subjects: filteredSelectedValues,
//     });
//   };
//   return (
//     <>
//       <div className="flex items-center xl:p-5 sm:p-0 justify-center">
//         <div className="w-full border rounded-3xl shadow-xl p-5 px-10">
//           <div className="mt-3  flex  items-center">
//             <div>
//               {" "}
//               <p className="text-2xl font-semibold ">Settings</p>
//             </div>
//           </div>

//           {/* tableee----------- */}
//           <div className="flex flex-wrap md:justify-start justify-center  space-x-5  border-b-2 text-base font-medium my-5">
//             {/* <NavLink
//               to=".././profileSettingTech"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Profile Settings
//             </NavLink> */}

//             <NavLink
//             //   to=".././specializationTech"
//               className="border-blue-500 border-b-2"
//             >
//               Subjects & WP
//             </NavLink>
// {/* 
//             <NavLink
//               to=".././otherDetail"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Other Details
//             </NavLink> */}
// {/* 
//             <NavLink
//               to=".././security"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Privacy & Security
//             </NavLink> */}

//             {/* <NavLink
//               to=".././techerNotiSetting"
//               className={({ isActive }) =>
//                 isActive
//                   ? "text-blue-500 border-b-2 border-blue-500"
//                   : undefined
//               }
//             >
//               Notification
//             </NavLink> */}
//           </div>
//           {/* end---------- */}

//           <div className="flex justify-between">
//             <div className="mt-5">
//               <p className="text-[22px] font-semibold ">
//                 Subjects & Work Preferences
//               </p>
//             </div>

//             <div className="flex space-x-5 mt-5 cursor-pointer ">
//               <p
//                 className="text-[14px] flex gap-x-2 text-[#5963F5] border border-[#5963F5] px-6 py-2 rounded-lg"
//                 onClick={() => {
//                   setFormData({
//                     teacher_id: teacher_id,
//                     class_id: "",
//                     subjects: [],
//                     type_id: typeId,
//                     online_charges: "",
//                     home_charges: "",
//                   });

//                   setShowModal(true);
//                 }}
//               >
//                 <FaPlus className="mt-1" />
//                 Add
//               </p>
//             </div>
//           </div>

//           <p className="mt-5 text-lg font-semibold">Main Subject</p>
//           {loading ? (
//             <div>
//               <div colSpan="9" className="py-5 px-1 text-center">
//                 <div className="fixed inset-0 flex flex-col items-center justify-center bg-gray-200 bg-opacity-5 backdrop-blur-sm z-50">
//                   <div className="w-12 h-12 border-4 border-t-4 border-gray-200 border-solid rounded-full animate-spin border-t-[#EE5F2B]"></div>
//                   <p className="mt-4 text-lg font-semibold text-[#EE5F2B]">
//                     Cabil...
//                   </p>
//                 </div>
//               </div>
//             </div>
//           ) : Object.entries(groupedSubjects).length === 0 ? (
//             <div>
//               <div colSpan="9" className="py-5 px-1 text-center">
//                 <p className="text-gray-500">
//                   No Specific Subjects are Selected
//                 </p>
//               </div>
//             </div>
//           ) : (
//             <div className="mt-5 w-full grid md:grid-cols-3  gap-4">
//               {Object.entries(groupedSubjects).map(([id, subjects]) => (
//                 <div
//                   key={id}
//                   className="flex flex-col border border-[#B5B7C0] rounded-2xl p-5 w-full"
//                 >
//                   <div>
//                     <p className="text-[16px] font-semibold">
//                       {subjects[0].class_name}
//                     </p>
//                     <div className="mb-4 mt-3">
//                       <p className="text-[14px] font-semibold">
//                         {subjects
//                           .map((subject) => subject.subject_name)
//                           .join(" | ")}
//                       </p>
//                     </div>
//                     {/* {subjects[0].home_charges && (
//                       <p className="text-[12px] text-[#B5B7C0] font-semibold">
//                         Home Charges: Rs.{subjects[0].home_charges}
//                       </p>
//                     )}
//                     {subjects[0].online_charges && (
//                       <p className="text-[12px] text-[#B5B7C0] font-semibold">
//                         Online Charges: Rs.{subjects[0].online_charges}
//                       </p>
//                     )} */}
//                     {(typeId === 1 || typeId === 3) &&
//                       subjects[0].home_charges && (
//                         <p className="text-[12px] text-[#B5B7C0] font-semibold">
//                           Home Charges: Rs.{subjects[0].home_charges}
//                         </p>
//                       )}
//                     {(typeId === 2 || typeId === 3) &&
//                       subjects[0].online_charges && (
//                         <p className="text-[12px] text-[#B5B7C0] font-semibold">
//                           Online Charges: Rs.{subjects[0].online_charges}
//                         </p>
//                       )}
//                   </div>

//                   <div className="flex text-blue-500 gap-x-3 text-[20px] items-center cursor-pointer mt-4">
//                     <div
//                       onClick={() =>
//                         handleFunctionEdit(
                   
//                           subjects[0].id,
//                           subjects[0].subject_name,
//                           subjects[0].class_name,
//                           subjects[0].home_charges,
//                           subjects[0].online_charges
//                         )
//                       }
//                     >
//                       <TbBallpen />
//                     </div>
//                     <button onClick={() => handleDeleteSubject(subjects[0].id)}>
//                       <FaRegTrashAlt />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           )}
//         </div>
//       </div>

//       {/* modal */}
//       {showModal ? (
//         <>
//           <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//             <div className="relative mx-auto max-w-lg w-full">
//               {/* {/content/} */}
//               <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel p-5">
//                 {/* {/header/} */}
//                 <div className="flex items-start justify-center  border-solid border-blueGray-200 rounded-t">
//                   <button
//                     className=" ml-auto  float-right text-2xl"
//                     onClick={() => setShowModal(false)}
//                   >
//                     <span> × </span>
//                   </button>
//                 </div>

//                 <div className="flex justify-center">
//                   <h1 className="text-2xl font-medium">Add Subject</h1>
//                 </div>

//                 <form onSubmit={handleSubmit} className="m-auto w-full">
//                   <div>
//                     <p className="text-lg mt-2 font-medium">Class</p>
//                   </div>
//                   <div>
//                     <select
//                       className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                       onChange={handleChange}
//                       name="class_id"
//                     >
//                       <option value={JSON.stringify({})}>Select Class</option>
//                       {classes.map((classItem, index) => (
//                         <option key={index} value={classItem.id}>
//                           {classItem.class_name}
//                         </option>
//                       ))}
//                     </select>
//                     {errors.class_id && (
//                       <div className="text-red-500 text-start text-sm">
//                         {`*Select class!`}
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     <p className="text-lg mt-2 font-medium">Subject</p>
//                   </div>
//                   <div>
//                     {/* new MultiSelection---------------------------------------------- */}

//                     <Select
//                       className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF]"
//                       options={options}
//                       isMulti={true}
//                       value={selectedOptions}
//                       onChange={handleChangeSub}
//                       closeMenuOnSelect={false}
//                       styles={{
//                         option: (provided, state) => ({
//                           ...provided,
//                           color: "#000",
//                         }),
//                         multiValue: (provided) => ({
//                           ...provided,
//                           backgroundColor: "#1E90FF",
//                           borderRadius: "0.25rem",
//                         }),
//                         multiValueLabel: (provided) => ({
//                           ...provided,
//                           color: "#fff",
//                         }),
//                         multiValueRemove: (provided) => ({
//                           ...provided,
//                           color: "#fff", // Remove icon color
//                           ":hover": {
//                             backgroundColor: "#1E90FF", // Hover color for remove icon
//                             color: "#fff", // Hover color for remove icon
//                           },
//                         }),
//                       }}
//                     />

//                     {/* end multi selection====================================== */}

//                     {errors.subject_id && (
//                       <div className="text-red-500 text-start text-sm">
//                         {`*Select Subject!`}
//                         {errorMessage}
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     <p className="text-lg mt-2 font-medium">
//                       Are you willing to teach the main subject
//                     </p>
//                     {errors.class_id && (
//                       <div className="text-red-500 text-start text-sm">
//                         {`*Select Slot!`}
//                       </div>
//                     )}
//                   </div>
//                   {/* <div className="flex justify-between mt-4 mx-3">
//                     <div className="flex items-center">
//                       <input
//                         id="radio1"
//                         type="radio"
//                         name="type_id"
//                         value="online"
//                         checked={selectedOption === "online"}
//                         onChange={() => {
//                           setSelectedOption("online");
//                           setFormData({ ...formData, type_id: "2" });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio1"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         Online Tutoring
//                       </label>
//                     </div>
//                     <div className="flex items-center">
//                       <input
//                         id="radio2"
//                         type="radio"
//                         name="type_id"
//                         value="home"
//                         checked={selectedOption === "home"}
//                         onChange={() => {
//                           setSelectedOption("home");
//                           setFormData({ ...formData, type_id: "1" });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio2"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         At Home
//                       </label>
//                     </div>
//                     <div className="flex items-center">
//                       <input
//                         id="radio3"
//                         type="radio"
//                         name="type_id"
//                         value="both"
//                         checked={selectedOption === "both"}
//                         onChange={() => {
//                           setSelectedOption("both");
//                           setFormData({ ...formData, type_id: "3" });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio3"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         Both Tutoring
//                       </label>
//                     </div>
//                   </div> */}

//                   {selectedOption === "online" && (
//                     <div>
//                       <p className="text-lg mt-2 font-medium">
//                         Charges per hour (online)- in PKR
//                       </p>
//                       <input
//                         type="text"
//                         name="online_charges"
//                         value={formData.online_charges}
//                         onChange={handleChange}
//                         className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                         placeholder="eg. Rs.1500 (per hour)"
//                       />
//                     </div>
//                   )}

//                   {selectedOption === "home" && (
//                     <div>
//                       <p className="text-lg mt-2 font-medium">
//                         Charges per hour (home)- in PKR
//                       </p>
//                       <input
//                         type="text"
//                         name="home_charges"
//                         value={formData.home_charges}
//                         onChange={handleChange}
//                         className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                         placeholder="eg. Rs.1500 (per hour)"
//                       />
//                     </div>
//                   )}

//                   {selectedOption === "both" && (
//                     <>
//                       <div>
//                         <p className="text-lg mt-2 font-medium">
//                           Charges per hour (online)- in PKR
//                         </p>
//                         <input
//                           type="text"
//                           name="online_charges"
//                           value={formData.online_charges}
//                           onChange={handleChange}
//                           className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                           placeholder="eg. Rs.1500 (per hour)"
//                         />
//                       </div>
//                       <div>
//                         <p className="text-lg mt-2 font-medium">
//                           Charges per hour (home)- in PKR
//                         </p>
//                         <input
//                           type="text"
//                           name="home_charges"
//                           value={formData.home_charges}
//                           onChange={handleChange}
//                           className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                           placeholder="eg. Rs.1500 (per hour)"
//                         />
//                       </div>
//                     </>
//                   )}

//                   <div className="flex justify-center my-5 mt-8 cursor-pointer">
//                     <button
//                       onClick={handleSubmit} // Ensure this triggers your submit function
//                       className={`bg-blue-500 w-fit hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg ml-2 focus:outline-none focus:shadow-outline ${
//                         isLoading ? "opacity-50 cursor-not-allowed" : ""
//                       }`}
//                       disabled={isLoading} // Disable button while loading
//                     >
//                       {isLoading ? (
//                         <svg
//                           className="animate-spin h-5 w-5 mr-3 inline"
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                       ) : (
//                         "Save"
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//           <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
//         </>
//       ) : null}
//       {/* modal-end */}

//       {/* modal */}
//       {showModalEdit ? (
//         <>
//           <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
//             <div className="relative mx-auto max-w-lg w-full">
//               {/* {/content/} */}
//               <div className="border-0 rounded-lg shadow-lg relative flex flex-col  bg-white outline-none focus:outline-none overflow-y-auto shiftmodel p-5">
//                 {/* {/header/} */}
//                 <div className="flex items-start justify-center  border-solid border-blueGray-200 rounded-t">
//                   <button
//                     className=" ml-auto  float-right text-2xl"
//                     onClick={() => {
//                       setFormData(initialFormData);
//                       setSelectedOptions([]);
//                       setShowModalEdit(false);
//                     }}
//                   >
//                     <span> × </span>
//                   </button>
//                 </div>

//                 <div className="flex justify-center">
//                   <h1 className="text-2xl font-medium">Edit Subject</h1>
//                 </div>

//                 <form onSubmit={handleSubmitEdit} className="m-auto w-full">
//                   <div>
//                     <p className="text-lg mt-2 font-medium">Class</p>
//                   </div>
//                   <div>
//                     <select
//                       className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                       onChange={handleChange}
//                       name="class_id"
//                       // value={edit.class_id}
//                     >
//                       <option value={edit.class_id}>{editclass}</option>
//                       {classes.map((classItem, index) => (
//                         <option
//                           key={index}
//                           value={classItem.id}
//                           selected={edit.class_id === classItem.id}
//                         >
//                           {classItem.class_name}
//                         </option>
//                       ))}
//                     </select>
//                     {errors.class_id && (
//                       <div className="text-red-500 text-start text-sm">
//                         {`*Select class!`}
//                       </div>
//                     )}
//                   </div>
//                   <div>
//                     <p className="text-lg mt-2 font-medium">Subject</p>
//                   </div>

//                   <Select
//                     className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] "
//                     options={options}
//                     isMulti={true}
//                     value={selectedOptions}
//                     onChange={handleChangeSub}
//                     closeMenuOnSelect={false}
//                     styles={{
//                       option: (provided, state) => ({
//                         ...provided,
//                         color: "#000",
//                       }),
//                       multiValue: (provided) => ({
//                         ...provided,
//                         backgroundColor: "#1E90FF",
//                         borderRadius: "0.25rem",
//                       }),
//                       multiValueLabel: (provided) => ({
//                         ...provided,
//                         color: "#fff",
//                       }),
//                       multiValueRemove: (provided) => ({
//                         ...provided,
//                         color: "#fff", // Remove icon color
//                         ":hover": {
//                           backgroundColor: "#1E90FF", // Hover color for remove icon
//                           color: "#fff", // Hover color for remove icon
//                         },
//                       }),
//                     }}
//                   />

//                   <div>
//                     <p className="text-lg mt-2 font-medium">
//                       Are you willing to teach the main subject
//                     </p>
//                     {errors.class_id && (
//                       <div className="text-red-500 text-start text-sm">
//                         {`*Select Slot!`}
//                       </div>
//                     )}
//                   </div>
//                   {/* <div className="flex justify-between mt-4 mx-3">
//                     <div className="flex items-center">
//                       <input
//                         id="radio1"
//                         type="radio"
//                         name="type_id"
//                         value="online"
//                         checked={formData.type_id === 2}
//                         onChange={() => {
//                           setSelectedOption("online");
//                           setFormData({ ...formData, type_id: 2 });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio1"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         Online Tuitoring
//                       </label>
//                     </div>
//                     <div className="flex items-center">
//                       <input
//                         id="radio2"
//                         type="radio"
//                         name="type_id"
//                         value="home"
//                         checked={formData.type_id === 1}
//                         onChange={() => {
//                           setSelectedOption("home");
//                           setFormData({ ...formData, type_id: 1 });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio2"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         At Home
//                       </label>
//                     </div>
//                     <div className="flex items-center">
//                       <input
//                         id="radio3"
//                         type="radio"
//                         name="type_id"
//                         value="both"
//                         checked={formData.type_id === 3}
//                         onChange={() => {
//                           setSelectedOption("both");
//                           setFormData({ ...formData, type_id: 3 });
//                         }}
//                         className="form-radio h-4 w-4 text-blue-600"
//                       />
//                       <label
//                         htmlFor="radio3"
//                         className="ml-2 text-gray-700 text-base font-medium"
//                       >
//                         Both Tuitoring
//                       </label>
//                     </div>
//                   </div> */}
//                   {formData.type_id === 2 && (
//                     <div>
//                       <p className="text-lg mt-2 font-medium">
//                         Charges Range (Online)
//                       </p>
//                       <input
//                         type="text"
//                         name="online_charges"
//                         value={editCharge}
//                         onChange={(e) => {
//                           handleChange(e);
//                           setEditCharge(e.target.value);
//                         }}
//                         className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                         placeholder="eg. Rs.1500 (per hour)"
//                       />
//                     </div>
//                   )}

//                   {formData.type_id === 1 && (
//                     <div>
//                       <p className="text-lg mt-2 font-medium">
//                         Charges Range (At Home)
//                       </p>
//                       <input
//                         type="text"
//                         name="home_charges"
//                         value={edithome}
//                         onChange={(e) => {
//                           handleChange(e);
//                           setEditHome(e.target.value);
//                         }}
//                         className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                         placeholder="eg. Rs.1500 (per hour)"
//                       />
//                     </div>
//                   )}

//                   {formData.type_id === 3 && (
//                     <>
//                       <div>
//                         <p className="text-lg mt-2 font-medium">
//                           Charges Range (Online)
//                         </p>
//                         <input
//                           type="text"
//                           name="online_charges"
//                           value={editCharge}
//                           onChange={(e) => {
//                             handleChange(e);
//                             setEditCharge(e.target.value);
//                           }}
//                           className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                           placeholder="eg. Rs.1500 (per hour)"
//                         />
//                       </div>
//                       <div>
//                         <p className="text-lg mt-2 font-medium">
//                           Charges Range (At Home)
//                         </p>
//                         <input
//                           type="text"
//                           name="home_charges"
//                           value={edithome}
//                           onChange={(e) => {
//                             handleChange(e);
//                             setEditHome(e.target.value);
//                           }}
//                           className="text-[#B5B7C0] text-sm dropdown-select w-full mt-2 rounded-lg outline-none bg-[#F9FBFF] px-5 py-2"
//                           placeholder="eg. Rs.1500 (per hour)"
//                         />
//                       </div>
//                     </>
//                   )}

//                   <div className="flex justify-center my-5 mt-8 cursor-pointer">
//                     <button
//                       className={`bg-blue-500 w-fit hover:bg-blue-600 text-white font-bold py-2 px-4 rounded-lg ml-2 focus:outline-none focus:shadow-outline ${
//                         isLoading2 ? "opacity-50 cursor-not-allowed" : ""
//                       }`}
//                       disabled={isLoading2}
//                     >
//                       {isLoading2 ? (
//                         <svg
//                           className="animate-spin h-5 w-5 text-white inline-block"
//                           xmlns="http://www.w3.org/2000/svg"
//                           fill="none"
//                           viewBox="0 0 24 24"
//                         >
//                           <circle
//                             className="opacity-25"
//                             cx="12"
//                             cy="12"
//                             r="10"
//                             stroke="currentColor"
//                             strokeWidth="4"
//                           ></circle>
//                           <path
//                             className="opacity-75"
//                             fill="currentColor"
//                             d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
//                           ></path>
//                         </svg>
//                       ) : (
//                         "Update"
//                       )}
//                     </button>
//                   </div>
//                 </form>
//               </div>
//             </div>
//           </div>
//           <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
//         </>
//       ) : null}
//       {/* modal-end */}
//     </>
//   );
// };

// export default AdminAddSubject;

import React, { useEffect, useMemo, useState } from "react";
import { FaPlus, FaRegTrashAlt } from "react-icons/fa";
import { TbBallpen } from "react-icons/tb";
import { NavLink } from "react-router-dom";
import apiKey from "../../../config/apiKey";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
import { getHitID } from "../../../config/HitIDStorage";
import { useTranslation } from "react-i18next";

const typeIdToOption = { 1: "home", 2: "online", 3: "both" };

const AdminAddSubject = () => {
  const { t } = useTranslation();
  const teacher_id = getHitID();
  const admin = JSON.parse(localStorage.getItem("edo-admin"));

  const [loading, setLoading] = useState(true);
  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [mySubjects, setMySubjects] = useState([]);

  const [typeId, setTypeId] = useState(null);
  const [selectedOption, setSelectedOption] = useState(""); // 'home' | 'online' | 'both'
  const [errors, setErrors] = useState({});
  const [errorMessage, setErrorMessage] = useState("");

  // add modal
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // edit modal
  const [showModalEdit, setShowModalEdit] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [editId, setEditId] = useState(null);
  const [editClassName, setEditClassName] = useState("");
  const [editClassId, setEditClassId] = useState("");
  const [editHome, setEditHome] = useState("");
  const [editOnline, setEditOnline] = useState("");
  const [editSelected, setEditSelected] = useState([]); // react-select values
  const [editTypeId, setEditTypeId] = useState(null);

  // form state (add)
  const [formData, setFormData] = useState({
    teacher_id,
    class_id: "",
    subjects: [],
    type_id: null, // will sync from typeId
    online_charges: "",
    home_charges: "",
  });
  const [selectedOptions, setSelectedOptions] = useState([]); // react-select values (add)

  // ---------- Fetch boot data ----------
  useEffect(() => {
    setLoading(true);
    Promise.all([
      axios.get(`${apiKey}/api/edolutions/teacher/classes`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      }),
      axios.get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      }),
      axios.get(`${apiKey}/api/edolutions/admin/ad-subjects/user/${teacher_id}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      }),
    ])
      .then(([classesRes, mySubRes, typeRes]) => {
        setClasses(classesRes.data || []);
        setMySubjects(mySubRes.data || []);

        const fetchedTypeId = typeRes.data?.type_id ?? null;
        setTypeId(fetchedTypeId);
        setSelectedOption(typeIdToOption[fetchedTypeId] || "");
        setFormData((p) => ({ ...p, type_id: fetchedTypeId || null }));
      })
      .catch((err) => {
        console.error(err);
        toast.error(t("adminDash.adminAddSubject.loadFailed"), { position: "bottom-right", theme: "colored" });
      })
      .finally(() => setLoading(false));
  }, [teacher_id, admin?.token]);

  // Fetch subjects for selected class (add modal)
  useEffect(() => {
    if (!formData.class_id) {
      setSubjects([]);
      return;
    }
    axios
      .get(`${apiKey}/api/edolutions/teacher/classes/${formData.class_id}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => setSubjects(res.data || []))
      .catch((err) => console.error(err));
  }, [formData.class_id, admin?.token]);

  // options for react-select
  const options = subjects.map((s) => ({ value: s.subject_id, label: s.subject_name }));

  // ---------- Helpers ----------
  const resetAddForm = () => {
    setFormData({
      teacher_id,
      class_id: "",
      subjects: [],
      type_id: typeId ?? null,
      online_charges: "",
      home_charges: "",
    });
    setSelectedOptions([]);
    setErrors({});
    setErrorMessage("");
  };

  const reloadMySubjects = () => {
    axios
      .get(`${apiKey}/api/edolutions/admin/ad-subjects?teacher_id=${teacher_id}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => setMySubjects(res.data || []))
      .catch((err) => console.error(err));
  };

  // Group by class_id (fix)
  const groupedByClass = useMemo(() => {
    const groups = {};
    (mySubjects || []).forEach((row) => {
      const key = row.class_id; // group by class_id
      if (!groups[key]) groups[key] = [];
      groups[key].push(row);
    });
    return groups;
  }, [mySubjects]);

  // handle react-select with duplicate filter
  const handleChangeSub = (selected) => {
    const selectedValues = (selected || []).map((o) => o.value);
    const existingIds = (mySubjects || []).map((s) => s.subject_id);
    const filteredValues = selectedValues.filter((v) => !existingIds.includes(v));

    if (filteredValues.length !== selectedValues.length) {
      setErrorMessage(t("adminDash.adminAddSubject.subjectsAlreadyExist"));
    } else {
      setErrorMessage("");
    }

    const filteredOptions = (selected || []).filter((o) => !existingIds.includes(o.value));
    setSelectedOptions(filteredOptions);
    setFormData((p) => ({ ...p, subjects: filteredValues }));
  };

  // ---------- Add Submit ----------
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    const payload = {
      ...formData,
      teacher_id,
      type_id: typeId ?? formData.type_id ?? null,
    };

    axios
      .post(`${apiKey}/api/edolutions/admin/ad-subjects`, payload, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || t("adminDash.adminAddSubject.saved"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        resetAddForm();
        setShowModal(false);
        reloadMySubjects();
      })
      .catch((err) => {
        const apiErr = err?.response?.data;
        setErrors(apiErr?.data || { general: t("adminDash.adminAddSubject.unexpectedError") });
      })
      .finally(() => setIsLoading(false));
  };

  // ---------- Edit ----------
  const handleFunctionEdit = (rowId, _subjectName, className, home_charges, online_charges) => {
    setEditId(rowId);
    setEditClassName(className);
    setEditHome(home_charges || "");
    setEditOnline(online_charges || "");
    setEditSelected([]);
    setErrors({});

    axios
      .get(`${apiKey}/api/edolutions/admin/ad-subjects/${rowId}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        // res.data is array of subjects under this class/row group
        const data = Array.isArray(res.data) ? res.data : [];
        if (data.length) {
          setEditClassId(data[0].class_id);
          setEditTypeId(data[0].type_id);
          setEditHome(data[0].home_charges || "");
          setEditOnline(data[0].online_charges || "");

          const defaults = data.map((s) => ({ value: s.subject_id, label: s.subject_name }));
          setEditSelected(defaults);

          setFormData((p) => ({
            ...p,
            teacher_id,
            class_id: data[0].class_id,
            type_id: data[0].type_id,
            online_charges: data[0].online_charges || "",
            home_charges: data[0].home_charges || "",
            subjects: defaults.map((d) => d.value),
          }));
        }
        setShowModalEdit(true);
      })
      .catch((err) => console.error(err));
  };

  const handleSubmitEdit = (e) => {
    e.preventDefault();
    if (!editId) return;

    setIsLoading2(true);
    const payload = {
      ...formData,
      teacher_id,
      class_id: formData.class_id || editClassId,
      type_id: formData.type_id || editTypeId || typeId,
    };

    axios
      .put(`${apiKey}/api/edolutions/admin/ad-subjects/${editId}`, payload, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || t("adminDash.common.update"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        setShowModalEdit(false);
        setEditId(null);
        reloadMySubjects();
      })
      .catch((err) => {
        const apiErr = err?.response?.data;
        setErrors(apiErr?.data || { general: t("adminDash.adminAddSubject.unexpectedError") });
      })
      .finally(() => setIsLoading2(false));
  };

  // ---------- Delete ----------
  const handleDeleteSubject = (id) => {
    axios
      .delete(`${apiKey}/api/edolutions/admin/ad-subjects/${id}`, {
        headers: { Authorization: `Bearer ${admin?.token}` },
      })
      .then((res) => {
        toast.success(res.data?.message || t("adminDash.adminAddSubject.deleted"), {
          position: "bottom-right",
          theme: "colored",
          style: { backgroundColor: "#2A3A54", color: "#fff" },
        });
        reloadMySubjects();
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || t("adminDash.adminAddSubject.deleteFailed"), {
          position: "bottom-right",
          theme: "colored",
        });
      });
  };

  // ---------- UI ----------
  return (
    <>
      <div className="flex items-center xl:p-5 sm:p-0 justify-center">
        <div className="w-full border rounded-3xl shadow-xl p-6 sm:p-8 bg-white">
          {/* Header Tabs */}
          <div className="mb-6">
            <p className="text-2xl font-bold">{t("adminDash.settings")}</p>
          </div>

          <div className="flex flex-wrap md:justify-start justify-center gap-6 border-b pb-3 text-base font-medium">
            <NavLink className="text-[#EE5F2B] border-b-2 border-[#EE5F2B] pb-1">{t("adminDash.adminAddSubject.specializationWp")}</NavLink>
          </div>

          {/* Title Row */}
          <div className="mt-6 flex items-center justify-between">
            <p className="text-[20px] sm:text-[22px] font-semibold">{t("adminDash.adminAddSubject.specializationWorkPreferences")}</p>
            <button
              onClick={() => {
                resetAddForm();
                setShowModal(true);
              }}
              className="flex items-center gap-2 text-sm font-semibold text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] px-4 py-2 rounded-xl shadow"
            >
              <FaPlus className="text-white" /> {t("adminDash.adminAddSubject.add")}
            </button>
          </div>

          {/* Main Subject List */}
          <p className="mt-6 text-lg font-semibold">{t("adminDash.adminAddSubject.mainSpecialization")}</p>

          {loading ? (
            <div className="py-8 text-center">
              <div className="inline-block w-12 h-12 border-4 border-gray-200 border-t-[#EE5F2B] rounded-full animate-spin"></div>
              <p className="mt-3 text-[#EE5F2B] font-semibold">Cabil...</p>
            </div>
          ) : Object.keys(groupedByClass).length === 0 ? (
            <div className="py-6 text-center text-gray-500">{t("adminDash.adminAddSubject.noSpecificSubjects")}</div>
          ) : (
            <div className="mt-5 w-full grid md:grid-cols-3 gap-4">
              {Object.entries(groupedByClass).map(([clsId, rows]) => {
                const first = rows[0] || {};
                const showHome = (typeId === 1 || typeId === 3) && !!first.home_charges;
                const showOnline = (typeId === 2 || typeId === 3) && !!first.online_charges;
                return (
                  <div key={clsId} className="flex flex-col border border-gray-200 rounded-2xl p-5 bg-white/70 hover:shadow-md transition">
                    <p className="text-[16px] font-semibold">{first.class_name || t("adminDash.adminAddSubject.classFallback")}</p>

                    <div className="mt-2 mb-3">
                      <p className="text-[14px] font-semibold text-gray-800">
                        {rows.map((r) => r.subject_name).join(" | ")}
                      </p>
                    </div>

                    <div className="flex gap-2 flex-wrap">
                      {showHome && (
                        <span className="text-xs px-2.5 py-1 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200">
                          {t("adminDash.adminAddSubject.homeAmount", { amount: first.home_charges })}
                        </span>
                      )}
                      {showOnline && (
                        <span className="text-xs px-2.5 py-1 rounded-full bg-indigo-50 text-indigo-700 border border-indigo-200">
                          {t("adminDash.adminAddSubject.sessionAmount", { amount: first.online_charges })}
                        </span>
                      )}
                    </div>

                    <div className="flex text-[#2A3A54] gap-x-4 text-[18px] items-center cursor-pointer mt-4">
                      <button
                        onClick={() =>
                          handleFunctionEdit(
                            first.id,
                            first.subject_name,
                            first.class_name,
                            first.home_charges,
                            first.online_charges
                          )
                        }
                        className="hover:text-[#2A3A54]"
                        title={t("adminDash.common.edit")}
                      >
                        <TbBallpen />
                      </button>
                      <button
                        onClick={() => handleDeleteSubject(first.id)}
                        className="text-red-500 hover:text-red-600"
                        title={t("adminDash.common.delete")}
                      >
                        <FaRegTrashAlt />
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>

      {/* ADD MODAL */}
      {showModal && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="relative w-full max-w-lg">
              <div className="bg-white rounded-3xl shadow-2xl p-5 sm:p-6">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-xl font-semibold">{t("adminDash.adminAddSubject.addSubject")}</h3>
                  <button
                    className="text-2xl leading-none"
                    onClick={() => {
                      resetAddForm();
                      setShowModal(false);
                    }}
                  >
                    ×
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-4">
                  {t("adminDash.adminAddSubject.teacherType")}: <span className="font-semibold capitalize">{selectedOption || "—"}</span>
                </p>

                <form onSubmit={handleSubmit} className="space-y-4">
                  {/* Class */}
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.adminAddSubject.class")}</label>
                    <select
                      className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                      onChange={(e) => {
                        setFormData((p) => ({ ...p, class_id: e.target.value, subjects: [] }));
                        setSelectedOptions([]);
                        setErrors((p) => ({ ...p, class_id: "" }));
                      }}
                      name="class_id"
                      value={formData.class_id}
                    >
                      <option value="">{t("adminDash.adminAddSubject.selectClass")}</option>
                      {classes.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.class_name}
                        </option>
                      ))}
                    </select>
                    {errors.class_id && <p className="text-red-500 text-xs mt-1">{t("adminDash.adminAddSubject.selectClassError")}</p>}
                  </div>

                  {/* Subjects */}
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.academicSubject.specializationLabel")}</label>
                    <Select
                      className="mt-1"
                      options={options}
                      isMulti
                      value={selectedOptions}
                      onChange={handleChangeSub}
                      closeMenuOnSelect={false}
                      styles={{
                        control: (base) => ({ ...base, borderRadius: 12, background: "#F9FBFF" }),
                        option: (provided) => ({ ...provided, color: "#000" }),
                        multiValue: (provided) => ({ ...provided, backgroundColor: "#1E90FF", borderRadius: 8 }),
                        multiValueLabel: (provided) => ({ ...provided, color: "#fff" }),
                        multiValueRemove: (provided) => ({
                          ...provided,
                          color: "#fff",
                          ":hover": { backgroundColor: "#1E90FF", color: "#fff" },
                        }),
                      }}
                    />
                    {(errors.subject_id || errorMessage) && (
                      <p className="text-red-500 text-xs mt-1">
                        * {errors.subject_id ? t("adminDash.adminAddSubject.selectSubjectError") : errorMessage}
                      </p>
                    )}
                  </div>

                  {/* Charges */}
                  {selectedOption === "online" && (
                    <div>
                      <label className="text-sm font-medium">{t("adminDash.adminAddSubject.chargesOnline")}</label>
                      <input
                        type="text"
                        name="online_charges"
                        value={formData.online_charges}
                        onChange={(e) => setFormData((p) => ({ ...p, online_charges: e.target.value }))}
                        className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                        placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                      />
                    </div>
                  )}
                  {selectedOption === "home" && (
                    <div>
                      <label className="text-sm font-medium">{t("adminDash.adminAddSubject.chargesHome")}</label>
                      <input
                        type="text"
                        name="home_charges"
                        value={formData.home_charges}
                        onChange={(e) => setFormData((p) => ({ ...p, home_charges: e.target.value }))}
                        className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                        placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                      />
                    </div>
                  )}
                  {selectedOption === "both" && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <label className="text-sm font-medium">{t("adminDash.adminAddSubject.onlinePkr")}</label>
                        <input
                          type="text"
                          name="online_charges"
                          value={formData.online_charges}
                          onChange={(e) => setFormData((p) => ({ ...p, online_charges: e.target.value }))}
                          className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                          placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium">{t("adminDash.adminAddSubject.homePkr")}</label>
                        <input
                          type="text"
                          name="home_charges"
                          value={formData.home_charges}
                          onChange={(e) => setFormData((p) => ({ ...p, home_charges: e.target.value }))}
                          className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                          placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                        />
                      </div>
                    </div>
                  )}

                  <div className="flex justify-center pt-2">
                    <button
                      type="submit"
                      className={`bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-5 rounded-xl shadow ${
                        isLoading ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <svg className="animate-spin h-5 w-5 mr-2 inline" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                      ) : (
                        t("adminDash.common.save")
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black/30 z-40" onClick={() => setShowModal(false)} />
        </>
      )}

      {/* EDIT MODAL */}
      {showModalEdit && (
        <>
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
            <div className="relative w-full max-w-lg">
              <div className="bg-white rounded-3xl shadow-2xl p-5 sm:p-6">
                <div className="flex items-center justify-between mb-1">
                  <h3 className="text-xl font-semibold">{t("adminDash.adminAddSubject.editSubject")}</h3>
                  <button
                    className="text-2xl leading-none"
                    onClick={() => {
                      setShowModalEdit(false);
                      setEditId(null);
                      setEditSelected([]);
                      setErrors({});
                    }}
                  >
                    ×
                  </button>
                </div>
                <p className="text-xs text-gray-500 mb-4">
                  {t("adminDash.adminAddSubject.teacherType")}: <span className="font-semibold capitalize">{typeIdToOption[formData.type_id] || typeIdToOption[editTypeId] || "—"}</span>
                </p>

                <form onSubmit={handleSubmitEdit} className="space-y-4">
                  {/* Class */}
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.adminAddSubject.class")}</label>
                    <select
                      className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                      name="class_id"
                      value={formData.class_id || editClassId || ""}
                      onChange={(e) => setFormData((p) => ({ ...p, class_id: e.target.value }))}
                    >
                      <option value={editClassId || ""}>{editClassName || t("adminDash.adminAddSubject.selectClass")}</option>
                      {classes.map((c) => (
                        <option key={c.id} value={c.id}>
                          {c.class_name}
                        </option>
                      ))}
                    </select>
                    {errors.class_id && <p className="text-red-500 text-xs mt-1">{t("adminDash.adminAddSubject.selectClassError")}</p>}
                  </div>

                  {/* Subject */}
                  <div>
                    <label className="text-sm font-medium">{t("adminDash.academicSubject.specializationLabel")}</label>
                    <Select
                      className="mt-1"
                      options={options}
                      isMulti
                      value={editSelected}
                      onChange={(sel) => {
                        setEditSelected(sel || []);
                        setFormData((p) => ({ ...p, subjects: (sel || []).map((o) => o.value) }));
                      }}
                      closeMenuOnSelect={false}
                      styles={{
                        control: (base) => ({ ...base, borderRadius: 12, background: "#F9FBFF" }),
                        option: (provided) => ({ ...provided, color: "#000" }),
                        multiValue: (provided) => ({ ...provided, backgroundColor: "#1E90FF", borderRadius: 8 }),
                        multiValueLabel: (provided) => ({ ...provided, color: "#fff" }),
                        multiValueRemove: (provided) => ({
                          ...provided,
                          color: "#fff",
                          ":hover": { backgroundColor: "#1E90FF", color: "#fff" },
                        }),
                      }}
                    />
                  </div>

                  {/* Charges */}
                  {(formData.type_id === 2 || editTypeId === 2) && (
                    <div>
                      <label className="text-sm font-medium">{t("adminDash.adminAddSubject.chargesOnlineShort")}</label>
                      <input
                        type="text"
                        name="online_charges"
                        value={formData.online_charges || editOnline || ""}
                        onChange={(e) => setFormData((p) => ({ ...p, online_charges: e.target.value }))}
                        className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                        placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                      />
                    </div>
                  )}
                  {(formData.type_id === 1 || editTypeId === 1) && (
                    <div>
                      <label className="text-sm font-medium">{t("adminDash.adminAddSubject.chargesHomeShort")}</label>
                      <input
                        type="text"
                        name="home_charges"
                        value={formData.home_charges || editHome || ""}
                        onChange={(e) => setFormData((p) => ({ ...p, home_charges: e.target.value }))}
                        className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                        placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                      />
                    </div>
                  )}
                  {(formData.type_id === 3 || editTypeId === 3) && (
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                      <div>
                        <label className="text-sm font-medium">{t("adminDash.adminAddSubject.onlinePkr")}</label>
                        <input
                          type="text"
                          name="online_charges"
                          value={formData.online_charges || editOnline || ""}
                          onChange={(e) => setFormData((p) => ({ ...p, online_charges: e.target.value }))}
                          className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                          placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-medium">{t("adminDash.adminAddSubject.homePkr")}</label>
                        <input
                          type="text"
                          name="home_charges"
                          value={formData.home_charges || editHome || ""}
                          onChange={(e) => setFormData((p) => ({ ...p, home_charges: e.target.value }))}
                          className="w-full mt-1 rounded-xl bg-[#F9FBFF] px-4 py-2.5 text-sm outline-none"
                          placeholder={t("adminDash.adminAddSubject.chargesPlaceholder")}
                        />
                      </div>
                    </div>
                  )}

                  <div className="flex justify-center pt-2">
                    <button
                      type="submit"
                      className={`bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-5 rounded-xl shadow ${
                        isLoading2 ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                      disabled={isLoading2}
                    >
                      {isLoading2 ? (
                        <svg className="animate-spin h-5 w-5 inline-block" viewBox="0 0 24 24">
                          <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                      ) : (
                        t("adminDash.common.update")
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <div className="fixed inset-0 bg-black/30 z-40" onClick={() => setShowModalEdit(false)} />
        </>
      )}
    </>
  );
};

export default AdminAddSubject;

